import { render, staticRenderFns } from "./PrecipitationDataContributionBasinCards.vue?vue&type=template&id=4e4e6b1d&scoped=true"
import script from "./PrecipitationDataContributionBasinCards.vue?vue&type=script&lang=js"
export * from "./PrecipitationDataContributionBasinCards.vue?vue&type=script&lang=js"
import style0 from "./PrecipitationDataContributionBasinCards.vue?vue&type=style&index=0&id=4e4e6b1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4e6b1d",
  null
  
)

export default component.exports